export const customFieldKeys = {
  all: () => ['custom-fields'] as const,
  definitions: () => [...customFieldKeys.all(), 'definitions'] as const,
  values: (personId: string) => [...customFieldKeys.all(), 'values', personId] as const,
  sections: () => [...customFieldKeys.all(), 'sections'] as const,
}
